<!--
    描述：项目管理--跟踪审计
    时间：2020-05-18
    Created by ws
-->
<template>
    <div class="tracking_audit" ref="audi">
        <div class="w-page-main">
            <div class="w-page-header">
                <div class="track-header">
                    <div class="menutab" v-show="showType === 'sheet'">
                        <el-tabs v-model="activeName" @tab-click="handleClick(activeName)">
                            <el-tab-pane label="申报进度款" name="1001"></el-tab-pane>
                            <el-tab-pane label="审核进度款" name="1002"></el-tab-pane>
                            <el-tab-pane label="数据对比" name="1003"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <!-- 单位切换 -->
                    <div class="track-center clearfix reset-input">
                        <div class="flex">
                            <span>单位：</span>
                            <el-select v-model="value" placeholder="请选择">
                                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <el-button-group class="flex ml10 pdr10" v-show="currentIndex !== 1003">
                                <el-button type="" :class="{ activeBtn: showType === 'sheet' }" size="mini" @click="changeType('sheet')">表格</el-button>
                                <el-button type="" :class="{ activeBtn: showType === 'chart' }" size="mini" @click="changeType('chart')">柱状图 / 挣值曲线</el-button>
                            </el-button-group>
                        </div>
                    </div>
                    <!-- 操作按钮 -->
                    <div class="track-center clearfix buttonclick">
                        <div class="flex">
                            <el-button type="success" size="mini" @click="chooseExport" v-if="showType !== 'chart'">自动分析生成报告</el-button>
                            <el-button type="primary" size="mini" icon="el-icon-menu" @click="changeFilter" v-if="showType !== 'chart'">列过滤</el-button>
                            <el-button plain type="primary" class="ml5" size="mini" icon="el-icon-download" v-if="roleBtns.includes('trackAudit-Excel')" @click="changeExport(currentIndex, 'excel')">导出Excel</el-button>
                            <el-button type="" class="ml5" size="mini" icon="el-icon-upload" v-if="roleBtns.includes('trackAudit-html')" @click="changeExport(currentIndex, 'html')">导出Html</el-button>
                            <el-button type="primary" v-if="showType !== 'chart'" class="ml5" size="mini" icon="el-icon-plus" v-show="roleBtns.includes('addPayment')" @click="addPayment">新增进度款</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-page-container classMore">
                <!-- 内容头部 -->
                <div class="tracking-top">
                    <el-form label-width="150px" :model="formInfo">
                        <el-row>
                            <el-col :span="6">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{ `控制价: ${headerInfo.kongZhiPrice}` }}
                                    </div>
                                    <div>
                                        <el-form-item label="控制价:">
                                            {{ headerInfo.kongZhiPrice }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="4">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{
                                        `累计申报进度期: ${formInfo.shenBaoQiShu} 期`
                                        }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计申报进度期:">
                                            {{ formInfo.shenBaoQiShu + " 期" }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="5">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{ `累计申报产值: ${headerInfo.shenBaoSum}` }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计申报产值:">
                                            {{ headerInfo.shenBaoSum }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="5">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{
                                        `累计申报进度款: ${headerInfo.declareProgressPayment}`
                                        }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计申报进度款:">
                                            {{ headerInfo.declareProgressPayment }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="4">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{
                                        `累计申报产值/合同价: ${formInfo.shenBaoBiLi}`
                                        }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计申报产值/合同价:">{{
                                            formInfo.shenBaoBiLi
                                            }}</el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{ `合同价: ${headerInfo.heTongPrice}` }}
                                    </div>
                                    <div>
                                        <el-form-item label="合同价:">
                                            {{ headerInfo.heTongPrice }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="4">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{ `累计审核进度期: ${formInfo.piZhunQiShu} 期` }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计审核进度期:">
                                            {{ formInfo.piZhunQiShu + " 期" }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="5">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{ `累计审核产值: ${headerInfo.piZhunSum}` }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计审核产值:">
                                            {{ headerInfo.piZhunSum }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="5">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{
                                        `累计审核进度款: ${headerInfo.examineProgressPayment}`
                                        }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计审核进度款:">
                                            {{ headerInfo.examineProgressPayment }}
                                        </el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="4">
                                <el-tooltip placement="bottom-start">
                                    <div slot="content">
                                        {{
                                        `累计审核产值/合同价: ${formInfo.piZhunBiLi}`
                                        }}
                                    </div>
                                    <div>
                                        <el-form-item label="累计审核产值/合同价:">{{
                                            formInfo.piZhunBiLi
                                            }}</el-form-item>
                                    </div>
                                </el-tooltip>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- 内容 -->
                <trackauditPayment ref="trackauditPayment" :unitName="unitName" :navIndex="currentIndex" :treeDataList="treeDataList" :periodsList="periodsList" v-if="showType === 'sheet' && currentIndex !== 1003"></trackauditPayment>
                <trackdataComparison ref="trackdataComparison" :unitName="unitName" :listData="listData" v-if="currentIndex === 1003" @refresh="getListData"></trackdataComparison>
                <trackEchart ref="trackEchart" :navIndex="currentIndex" :treeDataList="treeDataList" :periodsList="periodsList" :unitName="unitName" v-if="showType === 'chart' && currentIndex !== 1003"></trackEchart>
            </div>
        </div>
        <!-- 弹窗 -->
        <el-dialog :title="dialogModel.title" :visible.sync="dialogModel.visible" :width="dialogModel.width" :close-on-click-modal="false" @closed="handleClose">
            <!-- 初始新增选择 文件类型等 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogModel.addType === 1">
                <el-form ref="addForm" class="pdr5" :model="addForm" :rules="addRules" label-width="120px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="造价阶段" prop="phase">
                                <el-input v-model="addForm.phase" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="计价依据" prop="priceBasis">
                                <el-input v-model="addForm.priceBasis" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="期数" prop="numberPeriods">
                                <el-input type="number" v-model.number="addForm.numberPeriods" :min="1" @input="onInput">
                                    <template slot="prepend">第</template>
                                    <template slot="append">期</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="申报金额类型" style="text-align: left">
                                <el-radio v-model="declaredType" :label="0" :disabled="typeDisabled">当前</el-radio>
                                <el-radio v-model="declaredType" :label="1" :disabled="typeDisabled">累计</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item :label="
                                    addForm.costType === '0'
                                        ? '截止当期累计申报产值'
                                        : '截止当期累计审核产值'
                                " prop="amount" label-width="190px">
                                <el-input type="number" v-model.number="addForm.amount">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                            <el-form-item label="金额"
                                          prop="amount">
                                <el-input type="number"
                                          v-model.number="addForm.amount">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                            <el-form-item :label="
                                    addForm.costType === '0'
                                        ? '当期变更签证金额'
                                        : '当期实际支付金额'
                                " prop="changeActualValue" label-width="190px">
                                <el-input type="number" v-model.number="addForm.changeActualValue">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item :label="
                                    addForm.costType === '0'
                                        ? '截止当期累计申报进度款'
                                        : '截止当期累计审核进度款'
                                " prop="totalInterimCost" label-width="190px">
                                <el-input type="number" v-model.number="addForm.totalInterimCost">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="类型" class="text-left">
                        <el-radio v-model="addForm.costType" label="0" disabled>施工单位申报进度款</el-radio>
                        <el-radio v-model="addForm.costType" label="1" disabled>协审单位审核进度款</el-radio>
                    </el-form-item>
                    <el-form-item label="起止日期" prop="busImpList">
                        <el-date-picker v-model="addForm.busImpList" type="daterange" align="right" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="形象进度描述">
                        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容, 最多不可超过200个字" maxlength="200" show-word-limit v-model="addForm.busRemark">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="文件类型" class="text-left">
                        <el-radio v-model="addForm.fileType" disabled label="1">Excel</el-radio>
                        <el-radio v-model="addForm.fileType" label="0">XML</el-radio>
                    </el-form-item>
                    <el-form-item label="上传文件" :rules="[{ required: true }]">
                        <my-upload :aid="aid" mode="add" ref="myUpload" :multiple="false" :maxNum="1" :acceptType="acceptType"></my-upload>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 填写金额 与 文件金额不符合的说明 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogModel.addType === 10">
                <el-form class="pdr5" ref="softForm" :model="addForm" label-width="120px">
                    <el-form-item label="填报金额">
                        <el-input disabled v-model="addForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item label="文件读取金额">
                        <el-input disabled v-model="addForm.fileAmount"></el-input>
                    </el-form-item>
                    <el-form-item label="差款金额">
                        <el-input disabled :value="
                                parseFloat(addForm.fileAmount).sub(
                                    parseFloat(addForm.amount)
                                )
                            "></el-input>
                    </el-form-item>
                    <el-form-item label="差款幅度">
                        <el-input disabled :value="
                                parseFloat(addForm.amount) === 0
                                    ? 0
                                    : (
                                          ((parseFloat(addForm.fileAmount) -
                                              parseFloat(addForm.amount)) /
                                              parseFloat(addForm.amount)) *
                                          100
                                      ).toFixed(2)
                            ">
                            <template slot="append">
                                <span>%</span>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="说明" prop="softName" :rules="{ required: true, trigger: 'blur' }">
                        <el-input type="textarea" v-model="addForm.softName" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容, 最多不可超过360个字" maxlength="360" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <!-- excel 或 xml 的文件处理 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogModel.addType === 2">
                <cost-structure-list ref="structureList" v-if="addForm.fileType === '1'" :phase="addForm.phase"></cost-structure-list>
                <xml-preview v-else ref="xmlPreview" :tableData="addForm.sheetList" :fileName="addForm.param" :unitList="DanWeiByProjectList" :phase="addForm.phase" :costType="addForm.costType" :period="addForm.numberPeriods"></xml-preview>
            </div>
            <!-- excel 的文件预览页面 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogModel.addType === 3">
                <excel-preview :fileName="addForm.param1" :tableData="addForm.treeData"></excel-preview>
            </div>
            <!-- 列过滤弹窗 (申报款、审核款) -->
            <div class="filter-box h100 overflow-hidden" v-if="dialogModel.addType === 'filter' && currentIndex !== 1003">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0"></div>
                <el-checkbox-group v-model="checkedColumns" @change="handleCheck">
                    <el-checkbox v-for="(item, index) in filterColumns" :key="'过滤列' + index" class="mb5" :label="item.label">{{ item.sname }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 列过滤弹窗 (数据对比) -->
            <div class="filter-box h100 overflow-hidden" v-if="dialogModel.addType === 'filter' && currentIndex === 1003">
                <!-- <el-checkbox :indeterminate="isIndeterminate"
                             v-model="checkAll"
                             @change="handleCheckAllCompare">全选</el-checkbox> -->
                <el-row class="mt5 filter-header">
                    <el-col :span="2" class="filter-text">描述：</el-col>
                    <el-col :span="22">
                        <el-checkbox :indeterminate="isIndeterminateCompare.Declare" v-model="checkAllCompare.Declare" @change="handleCheckAllCompare($event, 'Declare')">全选</el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="mt5">
                    <el-col :span="2" class="filter-block">&nbsp;</el-col>
                    <el-col :span="22">
                        <el-checkbox-group v-model="compareCheck.Declare" @change="handleCheckNew($event, 'Declare')">
                            <el-checkbox v-for="(item, index) in filterColumnsNew.Declare" :key="'过滤列' + index" class="mb5" :label="item.label">{{ item.sname }}</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row class="mt5 filter-header">
                    <el-col :span="2" class="filter-text">当期：</el-col>
                    <el-col :span="22">
                        <el-col :span="22">
                            <el-checkbox :indeterminate="isIndeterminateCompare.current" v-model="checkAllCompare.current" @change="handleCheckAllCompare($event, 'current')">全选</el-checkbox>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row class="mt5">
                    <el-col :span="2" class="filter-block">&nbsp;</el-col>
                    <el-col :span="22">
                        <el-checkbox-group v-model="compareCheck.current" @change="handleCheckNew($event, 'current')">
                            <el-checkbox v-for="(item, index) in filterColumnsNew.current" :key="'过滤列' + index" class="mb5" :label="item.label">{{ item.sname }}</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row class="mt5 filter-header">
                    <el-col :span="2" class="filter-text">累计：</el-col>
                    <el-col :span="22">
                        <el-col :span="22">
                            <el-checkbox :indeterminate="isIndeterminateCompare.total" v-model="checkAllCompare.total" @change="handleCheckAllCompare($event, 'total')">全选</el-checkbox>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row class="mt5">
                    <el-col :span="2" class="filter-block"></el-col>
                    <el-col :span="22">
                        <el-checkbox-group v-model="compareCheck.total" @change="handleCheckNew($event, 'total')">
                            <el-checkbox v-for="(item, index) in filterColumnsNew.total" :key="'过滤列' + index" class="mb5" :label="item.label">{{ item.sname }}</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
            </div>
            <!-- 自动分析生成报告 -->
            <div class="h100 overflow-hidden analysis-container" v-if="dialogModel.addType === 'analysisExport'">
                <!-- 帮助说吗 -->
                <div class="note-text">
                    <p><i class="el-icon-info"></i> 帮助说明：</p>
                    <p>自动生成造价分析系统内所需要导出生成的所有分析报告。</p>
                    <p>需要生成导出的附件可根据个人需求选择。</p>
                    <p>附件中的基准值、对比值、分析规则、筛选条件等均有默认项，用户在自动分析时可选择默认项或选择其他选项。</p>
                    <p>注意：附件一为默认项，分析报告不可更改。导出生成报告前请检查基准值、对比值、分析规则、筛选条件的选择是否正确。</p>
                </div>
                <!-- 选择 块 -->
                <el-row v-for="(item, index) in analysisList" :key="'analysis' + index" class="block-row">
                    <el-col :span="5" :style="analysisColStyle(item)">
                        <div class="block-title">
                            <el-checkbox v-model="item.selected" @change="analysisSelected($event, item)" :disabled="item.disabled"></el-checkbox>&nbsp;
                            {{ item.title }}
                            <el-tooltip effect="light" placement="right">
                                <div slot="content" v-html="item.helpNotes"></div>
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </div>
                        <!-- 如果有副标题 -->
                        <div class="block-title block-subTitle" v-if="item.subTitle" @click="item.fn(item)">
                            {{ item.subTitle }}
                        </div>
                    </el-col>
                    <el-col :span="17" :style="activeAnalysisStyle(item)">
                        <!-- 复选框类型 -->
                        <template v-if="item.childrenType === 'checkbox'">
                            <el-col :span="3" class="text-center bd-right">
                                <el-checkbox v-model="item.checkAll" @change="analysisCheckAll($event, item)" label="全选" :disabled="item.disabled"></el-checkbox>
                            </el-col>
                            <el-col :span="21" class="pdl10 pdr10">
                                <el-checkbox v-for="(m, n) in item.children" :key="item.prop + '_' +  n" v-model="m.selected" :label="m.title" :disabled="m.disabled" @change="analysisChange($event, item)"></el-checkbox>
                            </el-col>
                        </template>
                        <!-- 单选类型 -->
                        <template v-if="item.childrenType === 'radio'">
                            <div v-for="(m, n) in item.children" :key="m.prop + item.prop" class="overflow-hidden" :class="{'bd-top': n > 0}">
                                <el-col :span="3" class="text-center bd-right">{{ m.title }}</el-col>
                                <el-col :span="21" class="pdl10 pdr10 bd-right">
                                    <!-- 单选框 -->
                                    <template v-if="m.type === 'radio'">
                                        <el-radio-group v-model="m.selected">
                                            <el-radio v-for="(radioItem, radioIndex) in m.list" :key="item.prop + m.title + radioIndex" :label="radioItem.prop" :disabled="radioItem.disabled">{{ radioItem.title }}</el-radio>
                                        </el-radio-group>
                                    </template>
                                    <!-- 复选框 -->
                                    <template v-if="m.type === 'checkbox'">
                                        <el-checkbox-group v-model="m.selected">
                                            <el-checkbox v-for="(checkItem, checkIndex) in m.list" :key="item.prop + m.title + checkIndex" :label="checkItem.prop" :disabled="checkItem.disabled">{{ checkItem.title }}</el-checkbox>
                                        </el-checkbox-group>
                                    </template>
                                </el-col>
                            </div>
                        </template>

                        <!-- 混合类型 -->
                        <template v-if="item.childrenType === 'mix'">
                            <div v-for="(m, n) in item.children" :key="m.prop + item.prop" class="overflow-hidden" :class="{'bd-top': n > 0}">
                                <el-col :span="3" class="text-center bd-right">
                                    <template v-if="m.type === 'radio'">{{ m.title }}</template>
                                    <template v-if="m.type === 'checkbox'">
                                        <el-checkbox v-model="item.checkAll" @change="analysisCheckAll($event, item)" :label="m.title" :disabled="item.disabled"></el-checkbox>
                                    </template>
                                </el-col>
                                <el-col :span="21" class="pdl10 pdr10 bd-right">
                                    <!-- 单选框 -->
                                    <template v-if="m.type === 'radio'">
                                        <el-radio-group v-model="m.selected">
                                            <el-radio v-for="(radioItem, radioIndex) in m.list" :key="item.prop + m.title + radioIndex" :label="radioItem.prop" :disabled="radioItem.disabled">{{ radioItem.title }}</el-radio>
                                        </el-radio-group>
                                    </template>
                                    <!-- 复选框 -->
                                    <template v-if="m.type === 'checkbox'">
                                        <el-checkbox-group v-model="m.selected" @change="analysisMixChange($event, m, item)">
                                            <el-checkbox v-for="(checkItem, checkIndex) in m.list" :key="item.prop + m.title + checkIndex" :label="checkItem.prop" :disabled="checkItem.disabled">{{ checkItem.title }}</el-checkbox>
                                        </el-checkbox-group>
                                    </template>
                                </el-col>
                            </div>
                        </template>
                    </el-col>
                    <el-col :span="2" class="tools-box">
                        <el-button icon="el-icon-plus" class="tools-btn" type="primary" size="mini" v-show="item.childrenType === 'radio'" @click="addParams(item.prop, index)"></el-button>
                        <el-button icon="el-icon-minus" class="tools-btn" type="danger" size="mini" v-show="item.childrenType === 'radio' && item.btnIndex !== 0" @click="removeParams(item.prop, index)"></el-button>
                    </el-col>
                </el-row>
            </div>
            <!-- 底部按钮 -->
            <div slot="footer" v-if="dialogModel.type === 'add'" class="dialog-footer text-center">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" size="small" :loading="btnLoading" @click="doConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog title="上传进度" width="65%" class="progressDialog" :visible.sync="progressData.show" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :append-to-body="true">
            <div>
                <el-row v-for="(i, index) in progressData.eventList" :key="'eventList' + index">
                    <el-col :span="8">
                        <div class="inputTitle">
                            {{ i.name }}
                        </div>
                    </el-col>
                    <el-col :span="16">
                        <el-row class="progressBox" :gutter="20">
                            <el-col :span="10" class="progressCol">
                                <el-progress :text-inside="true" :stroke-width="26" :percentage="i.progress"></el-progress>
                            </el-col>
                            <el-col :span="12" class="progressInfo">
                                {{ i.progressInfo }}&nbsp;
                                <i class="el-icon-loading" v-show="i.progressLoading"></i>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
        <!-- 规则弹窗 -->
        <el-dialog :visible.sync="ruleDialog.visible" :title="ruleDialog.title" :width="ruleDialog.width" :close-on-click-modal="false" @closed="handleRuleClose">
            <!-- 第二步 打开具体规则 -->
            <template v-if="ruleDialog.step === 2">
                <rule-table ref="ruleTable" :mode="ruleDialog.mode" :isSys="isSys" needSave :showTools="false"></rule-table>
            </template>
            <!-- footer 组件 -->
            <div slot="footer" class="dialog-footer text-center">
                <el-button size="small" @click="ruleDialog.visible = false">取 消</el-button>
                <el-button type="primary" size="small" :loading="ruleDialog.btnLoading" @click="onRuleConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 排序弹窗 -->
        <el-dialog :title="sortDialog.title" :visible.sync="sortDialog.visible" :width="sortDialog.width" :close-on-click-modal="false" @closed="handleSortClose">
            <!-- 联合排序 -->
            <div class="text-center h100 overflow-hidden" v-if="sortDialog.visible && sortDialog.type === 'inventory'">
                <el-row class="check-row mb10">
                    <el-col :span="4" class="check-name text-overflow">
                        <el-checkbox class="ml10" @change="handleAllSortChange($event, 'inventoryList')" v-model="checkSort.inventory">全选</el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in sortObj.inventoryList" :label="item.key" :key="'排序' + index" v-model="item.visible">{{ item.label }}</el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="mb20 info-text">
                    <i class="el-icon-warning"></i> 帮助说明：
                    <p>根据联合排序的条件选项，分析、对比所选择的一个或多个单位工程中相同的清单项综合单价是否不一致，条件可单选或多选。</p>
                    <p>清单编码：筛选清单编码前九位数字一致的清单项。清单编码默认编码中前九位数字，有字母的清单编码，取编码后面数字中的前九位数。</p>
                    <p>清单名称：筛选清单名称一致的清单项</p>
                    <p>清单特征；筛选清单特征一致的清单项</p>
                    <p>计量单位：筛选计量单位一致的清单项</p>
                </el-row>
                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="sortDialog.visible = false" size="small">取 消
                    </el-button>
                    <el-button type="primary" size="small" :loading="sortDialog.btnLoading" @click="doSort">确 定
                    </el-button>
                </div>
            </div>
            <!-- 分类排序 -->
            <div class="text-center h100 overflow-hidden" v-if="sortDialog.visible && sortDialog.type === 'material'">
                <el-row class="check-row mb10">
                    <el-col :span="4" class="check-name text-overflow">
                        <el-checkbox class="ml10" @change="handleAllSortChange($event, 'materialList')" v-model="checkSort.material">全选</el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in sortObj.materialList" :label="item.key" :key="'排序' + index" v-model="item.visible">{{ item.label }}</el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="mb20 info-text">
                    <i class="el-icon-warning"></i> 帮助说明：
                    <p>根据分类排序的条件选项，分析、对比所选择的一个或多个单位工程中相同的材料单价是否不一致，条件可单选或多选。</p>
                    <p>材料编码：筛选材料编码一致的材料清单项。材料编码默认编码中的前九位。</p>
                    <p>材料名称：筛选材料名称一致的材料清单项。</p>
                    <p>规格型号：筛选规格型号一致的材料清单项。</p>
                    <p>计量单位：筛选计量单位一致的材料清单项。</p>
                </el-row>
                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="sortDialog.visible = false" size="small">取 消
                    </el-button>
                    <el-button type="primary" size="small" :loading="sortDialog.btnLoading" @click="doSort">确 定
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// components
import trackauditPayment from "../../project-management/tracking-audit/track_audit_payment_table";
import { mapState } from "vuex";
import trackdataComparison from "../../project-management/tracking-audit/track_data_comparison";
import trackEchart from "../../project-management/tracking-audit/track_echart";
import xmlPreview from "../cost-files/xml-preview"; //XML
import excelPreview from "../cost-files/excel-preview";
import myUpload from "components/upload/upload";
import ruleTable from "@/views/basic-template/rule-setting/rule_table.vue";

// js
import { deleteFile } from '@/api/modules/upload'
import { selectDanWeiByProject } from "@/api/modules/project_costfiles";
import { getProjectCostAnalysis } from '@/api/modules/analysisCharts'
import { exportExcel, dateFormat } from "@/utils/tools";
import {
    newProgressPayment,
    parseXml,
    judgeIsDataByPeriod,
    saveXmlAndPayment,
    auditEcho,
    selectPeriodsData,
    auditEchoHeader,
    getDeclaredType,
    checkFileZipIsData
} from "@/api/modules/trackAudit";
import { getRulesList } from "@/api/modules/clearSection.js";
export default {
    components: {
        trackauditPayment,
        xmlPreview,
        excelPreview,
        myUpload,
        trackdataComparison,
        trackEchart,
        ruleTable
    },
    data() {
        // 检测期数
        let checkNumber = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("期数不能为空"));
            }
            setTimeout(() => {
                if (value < 1 || value > 99) {
                    callback(new Error("值为大于等于1, 小于等于99的正整数"));
                } else if (!Number.isInteger(value)) {
                    callback(new Error("请输入正整数"));
                } else {
                    callback();
                }
            }, 500);
        };
        // 检测金额
        let checkMoney = (rule, value, callback) => {
            if (!value && value !== 0) {
                return callback(new Error("金额不能为空"));
            }
            setTimeout(() => {
                if (!Number(value) < 0 || parseFloat(value) < 0) {
                    callback(new Error("请输入正数"));
                } else {
                    callback();
                }
            }, 500);
        };
        return {
            // 列过滤
            compareCheck: {
                current: ["taostValue", "costMoney", "tostValue", "sunMoney"],
                total: ["applyMoney", "approvalMoney", "visaMoney", "payMoney"],
                Declare: [],
            },
            // 已选择的数组
            checkedColumns: [
                "heTongPrice",
                "shenBaoSum",
                "piZhunSum",
                "shenBaoBiLi",
                "piZhunBiLi",
                "shengYuShenBao",
            ],
            periodsList: [], // 期数数组
            activeName: "1001",
            showType: "sheet", // 当前展示模式
            options: [{
                    value: "1",
                    label: "元",
                },
                {
                    value: "2",
                    label: "万元",
                },
            ],
            treeDataList: [],
            value: "1",
            isIndeterminate: true,
            checkAll: true,
            isIndeterminateCompare: {
                Declare: true,
                current: true,
                total: true,
            },
            checkAllCompare: {
                Declare: false,
                current: false,
                total: false,
            }, // 是否全选
            //内容头部表单信息
            formInfo: {
                shenBaoSum: 0, //累计申报产值
                piZhunQiShu: 0, //累计批进度期
                piZhunSum: 0, //累计批准产值
                shenBaoBiLi: 0, //累计申报百分比
                declareProgressPayment: 0, // 累计批准进度款
                examineProgressPayment: 0, // 累计批准进度款
                kongZhiPrice: 0, //控制价
                shenBaoQiShu: 0, //累计申报进度期
                piZhunBiLi: 0, //累计批准百分比
                heTongPrice: 0, //合同价
            },
            // 弹窗对象
            dialogModel: {
                title: "新增进度款",
                visible: false,
                width: "750px",
                type: "add",
                addType: 0,
            },
            // 新增对象
            addForm: {
                phase: "", // 造价阶段
                priceBasis: "", // 计价依据
                numberPeriods: "", // 第几期
                amount: 0, // 金额
                changeActualValue: 0, // 申报 或 实际支付金额
                totalInterimCost: 0, // 进度款
                costType: "0", // 所选类型
                busImpList: [], // 起止日期数组
                dateBirth: "", // 开始日期
                stopDate: "", // 结束日期
                busRemark: "", // 备注
                fileAmount: 0, // 文件金额
                fileType: "0", // 文件类型
                param: "", // 文件名称
                param1: "", // 结构名称
                treeId: "", // 当前树id
                isData: "", // 当前是否有数据
                sheetList: [], // 数组
                treeData: [], // 格式化后的树结构数组
                softName: '',
            },
            // 表单验证规则
            addRules: {
                // 期数
                numberPeriods: [{
                    required: true,
                    validator: checkNumber,
                    trigger: "blur",
                }, ],
                // 产值
                amount: [{
                    required: true,
                    validator: checkMoney,
                    trigger: "blur",
                }, ],
                // 签证金额/支付金额
                changeActualValue: {
                    required: true,
                    validator: checkMoney,
                    trigger: "blur",
                },
                // 进度款
                totalInterimCost: [{
                    required: true,
                    validator: checkMoney,
                    trigger: "blur",
                }, ],
                // 起止日期
                busImpList: {
                    required: true,
                    type: "array",
                    message: "请选择起止日期",
                    trigger: "change",
                },
            },
            currentIndex: 1001,
            DanWeiByProjectList: [], //工程数据
            aid: "", // 上传组件业务表ID
            fileList: [],
            listData: [], //currentIndex ===1003
            //重置表单数据
            resetaddForm: {
                danWeiId: "",
            },
            btnLoading: false,
            // 导出对象
            exportObj: {
                param2: "", //表头字段
                projectId: "", // 项目ID
                type: "", // 类型（0 是申报进度款  1是批准进度款）
                unitType: "", // 单位（元、万元）
            },
            // 申报类型是否可编辑
            typeDisabled: false,
            declaredType: 0,
            // 全局loading
            pageLoading: false,
            // 进度条
            saveFileId: [],
            progressData: {
                show: false,
                eventList: [],
            },
            progressOverWatch: null,

            // 自动分析数组
            analysisList: [
                {
                    title: '分析报告',
                    prop: 'analysisReport',
                    selected: true,
                    helpNotes: '项目：概算价、控制价、报审价、中标价、报审价、初审价、审定价、中各单项工程所占比例及汇总。<br>单项工程：单项工程内部各单位工程所占比例及汇总;<br>单位工程：单位工程内部各分部所占比例及汇总',
                    disabled: true,
                    childrenType: 'checkbox',
                    checkAll: true,
                    children: [{
                            title: '封面',
                            prop: 'head',
                            type: 'checkbox',
                            selected: true,
                            disabled: true,
                        },
                        {
                            title: '项目基本信息',
                            prop: 'baseInfo',
                            type: 'checkbox',
                            selected: true,
                            disabled: true,
                        }
                    ]
                },
                {
                    title: '附件1：跟踪审计',
                    prop: 'trackingAudit',
                    selected: true,
                    helpNotes: '项目申报产值、 进度款与项目审核产值、 进度款金额每期 / 累计的数值比较。 ',
                    disabled: false,
                    childrenType: 'checkbox',
                    checkAll: true,
                    children: [{
                            title: '申报进度款',
                            prop: 'apply',
                            type: 'checkbox',
                            selected: true,
                            disabled: false,
                            exportObj: {
                                projectId: this.curProjectId,
                            }
                        },
                        {
                            title: '审核进度款',
                            prop: 'audit',
                            type: 'checkbox',
                            selected: true,
                            disabled: false,
                            exportObj: {}
                        },
                        {
                            title: '数据对比',
                            prop: 'compare',
                            selected: true,
                            type: 'checkbox',
                            disabled: false,
                            exportObj: {}
                        }
                    ]
                },
                {
                    title: '附件2：六算分析表',
                    prop: 'analysisSheet',
                    selected: true,
                    helpNotes: '默认基准值为中标价，可修改。项目概算价、控制价、中标价、报审价、初审价、审定价等造价文件数据与基准值的对比。',
                    disabled: false,
                    phase1: '',
                    phase2: '',
                    btnIndex: 0,
                    childrenType: 'mix',
                    subTitle: '',
                    checkAll: false,
                    children: [
                        {
                            title: '基准值',
                            prop: 'base',
                            type: 'radio',
                            selected: '1007003',
                            list: [{
                                    title: '概算价',
                                    disabled: false,
                                    prop: '1007001'
                                },
                                {
                                    title: '控制价',
                                    disabled: false,
                                    prop: '1007002'
                                },
                                {
                                    title: '中标价',
                                    disabled: false,
                                    prop: '1007003'
                                },
                                {
                                    title: '报审价',
                                    disabled: false,
                                    prop: '1007004'
                                },
                                {
                                    title: '初审价',
                                    disabled: false,
                                    prop: '1007005'
                                },
                                {
                                    title: '审定价',
                                    disabled: false,
                                    prop: '1007006'
                                },
                            ]
                        },
                        {
                            title: '对比值',
                            prop: 'compare',
                            type: 'checkbox',
                            selected: ['1007006'],
                            list: [{
                                    title: '概算价',
                                    disabled: false,
                                    prop: '1007001'
                                },
                                {
                                    title: '控制价',
                                    disabled: false,
                                    prop: '1007002'
                                },
                                {
                                    title: '中标价',
                                    disabled: false,
                                    prop: '1007003'
                                },
                                {
                                    title: '报审价',
                                    disabled: false,
                                    prop: '1007004'
                                },
                                {
                                    title: '初审价',
                                    disabled: false,
                                    prop: '1007005'
                                },
                                {
                                    title: '审定价',
                                    disabled: false,
                                    prop: '1007006'
                                }
                            ]
                        }
                    ]
                },
                {
                    title: '附件3.1：详细分析',
                    prop: 'analysisDetail',
                    selected: true,
                    helpNotes: `对比值与基准值两个造价文件清单子目中清单编码、清单名称、清单特征、计量单位、工程量、单价、合价之间的差异分析。<br>生成报告前序选择分析规则，分析规则选项为系统默认的规则和操作人再系统内已经设置保存的规则或类似清单。`,
                    disabled: false,
                    phase1: '',
                    phase2: '',
                    rules: {},
                    btnIndex: 0,
                    childrenType: 'radio',
                    subTitle: '查看修改分析规则',
                    fn: (item) => {
                        // console.log(this)
                        this.openRule(item)
                    },
                    children: [{
                            title: '基准值',
                            prop: 'base',
                            type: 'radio',
                            selected: '1007003',
                            list: [{
                                    title: '概算价',
                                    disabled: true,
                                    prop: '1007001'
                                },
                                {
                                    title: '控制价',
                                    disabled: false,
                                    prop: '1007002'
                                },
                                {
                                    title: '中标价',
                                    disabled: false,
                                    prop: '1007003'
                                },
                                {
                                    title: '报审价',
                                    disabled: false,
                                    prop: '1007004'
                                },
                                {
                                    title: '初审价',
                                    disabled: false,
                                    prop: '1007005'
                                },
                                {
                                    title: '审定价',
                                    disabled: false,
                                    prop: '1007006'
                                },
                            ]
                        },
                        {
                            title: '对比值',
                            prop: 'compare',
                            type: 'radio',
                            selected: '1007006',
                            list: [{
                                    title: '概算价',
                                    disabled: true,
                                    prop: '1007001'
                                },
                                {
                                    title: '控制价',
                                    disabled: false,
                                    prop: '1007002'
                                },
                                {
                                    title: '中标价',
                                    disabled: false,
                                    prop: '1007003'
                                },
                                {
                                    title: '报审价',
                                    disabled: false,
                                    prop: '1007004'
                                },
                                {
                                    title: '初审价',
                                    disabled: false,
                                    prop: '1007005'
                                },
                                {
                                    title: '审定价',
                                    disabled: false,
                                    prop: '1007006'
                                }
                            ]
                        }
                    ]
                },
                {
                    title: '附件4：清单检查',
                    prop: 'analysisInventory',
                    selected: true,
                    helpNotes: '联合排序：根据联合排序的条件选项，分析、对比所选择的一个或多个单位工程中相同的清单项综合单价是否不一致，条件可单选或多选。',
                    disabled: false,
                    childrenType: 'checkbox',
                    checkAll: false,
                    subTitle: '查看修改联合排序项',
                    fn: (item) => {
                        this.openSort('inventory', item)
                    },
                    sortField: ["code", "project_name", "project_features", "unit"],
                    children: [{
                            title: '概算价',
                            type: 'checkbox',
                            selected: false,
                            disabled: true,
                            prop: '1007001'
                        },
                        {
                            title: '控制价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007002'
                        },
                        {
                            title: '中标价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007003'
                        },
                        {
                            title: '报审价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007004'
                        },
                        {
                            title: '初审价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007005'
                        },
                        {
                            title: '审定价',
                            type: 'checkbox',
                            selected: true,
                            disabled: false,
                            prop: '1007006'
                        },
                    ]
                },
                {
                    title: '附件5：材价检查',
                    prop: 'analysisMaterial',
                    selected: true,
                    helpNotes: '分类排序：根据分类排序的条件选项，分析、对比所选择的一个或多个单位工程中相同的材料单价是否不一致，条件可单选或多选。',
                    disabled: false,
                    childrenType: 'checkbox',
                    checkAll: false,
                    subTitle: '查看修改分类排序项',
                    fn: (item) => {
                        this.openSort('material', item)
                    },
                    sortField: ["code", "name", "specification", "unit"],
                    children: [{
                            title: '概算价',
                            type: 'checkbox',
                            selected: false,
                            disabled: true,
                            prop: '1007001'
                        },
                        {
                            title: '控制价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007002'
                        },
                        {
                            title: '中标价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007003'
                        },
                        {
                            title: '报审价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007004'
                        },
                        {
                            title: '初审价',
                            type: 'checkbox',
                            selected: false,
                            disabled: false,
                            prop: '1007005'
                        },
                        {
                            title: '审定价',
                            type: 'checkbox',
                            selected: true,
                            disabled: false,
                            prop: '1007006'
                        },
                    ]
                },
                {
                    title: '附件6.1：签证对比',
                    prop: 'analysisVisa',
                    selected: true,
                    helpNotes: `签证报价中清单项与项目商务标等造价文件中的清单项进行对比，筛选是否有相同清单或类似清单。`,
                    disabled: false,
                    phase1: '',
                    phase2: '',
                    rules: {},
                    btnIndex: 0,
                    childrenType: 'radio',
                    children: [{
                            title: '类似清单',
                            prop: 'base',
                            type: 'radio',
                            selected: '1007006',
                            list: [{
                                    title: '概算价',
                                    disabled: true,
                                    prop: '1007001'
                                },
                                {
                                    title: '控制价',
                                    disabled: false,
                                    prop: '1007002'
                                },
                                {
                                    title: '中标价',
                                    disabled: false,
                                    prop: '1007003'
                                },
                                {
                                    title: '报审价',
                                    disabled: false,
                                    prop: '1007004'
                                },
                                {
                                    title: '初审价',
                                    disabled: false,
                                    prop: '1007005'
                                },
                                {
                                    title: '审定价',
                                    disabled: false,
                                    prop: '1007006'
                                },
                            ]
                        },
                        {
                            title: '签证价',
                            prop: 'visa',
                            type: 'radio',
                            selected: '1055003',
                            list: [{
                                    title: '签证报审价',
                                    disabled: false,
                                    prop: '1055001'
                                },
                                {
                                    title: '签证初审价',
                                    disabled: false,
                                    prop: '1055002'
                                },
                                {
                                    title: '签证审定价',
                                    disabled: false,
                                    prop: '1055003'
                                }
                            ]
                        }
                    ]
                },
            ],
            // 规则弹窗相关
            ruleDialog: {
                title: "手动分析",
                visible: false,
                width: "1200px",
                mode: "edit",
                step: 0,
                btnLoading: false,
            },
            curRule: {},
            curDetailItem: {},
            isSys: '2',
            // 分类、联合 排序
            sortDialog: {
                title: "联合排序",
                visible: false,
                width: "1000px",
                type: "inventory",
                btnLoading: false,
            },
            sortObj: {
                inventoryList: [{
                        label: "清单编码",
                        key: "code",
                        prop: 'code',
                        visible: true,
                    },
                    {
                        label: "清单名称",
                        key: "project_name",
                        prop: 'projectName',
                        visible: true,
                    },
                    {
                        label: "清单特征",
                        key: "project_features",
                        prop: 'projectFeatures',
                        visible: true,
                    },
                    {
                        label: "计量单位",
                        key: "unit",
                        prop: 'unit',
                        visible: true,
                    }
                ],
                materialList: [{
                        label: "材料编码",
                        key: "code",
                        prop: "code",
                        visible: true,
                    },
                    {
                        label: "材料名称",
                        key: "name",
                        prop: "sname",
                        visible: true,
                    },
                    {
                        label: "规格型号",
                        key: "specification",
                        prop: 'specification',
                        visible: true,
                    },
                    {
                        label: "计量单位",
                        key: "unit",
                        prop: "unit",
                        visible: true,
                    }
                ]
            },
            checkSort: {
                inventory: true,
                material: true
            },
            // 定时器
            timer: null
        };
    },
    created() {
        //初始化接口
        this.$nextTick(() => {
            this.DanWeiByProject();
            this.getBaseInfo();
            this.gettableData();
            this.getheadform();

            // 获取规则
            this.getRules()
            // 删除附件
            if (this.saveFileId.length > 0) {
                this.deleteFile()
            }

            // 获取是否有价格
            this.judgePrice()
        });
    },
    methods: {
        //造价文件-选择xml文件点击确定跳转页面中单位工程的下拉列表接口
        DanWeiByProject() {
            selectDanWeiByProject({ id: this.curProjectId }).then((res) => {
                if (res.code === 0) {
                    this.DanWeiByProjectList = res.data;
                }
            });
        },

        // 获取造价阶段信息
        getBaseInfo() {
            newProgressPayment({ id: this.curProjectId }).then((res) => {
                if (res && res.code === 0) {
                    this.addForm.phase = res.data.Phase;
                    this.addForm.priceBasis = res.data.priceBasis;
                }
            });
        },

        // 获取 项目申报金额类型
        getProjectType() {
            getDeclaredType({
                id: this.curProjectId,
            }).then((res) => {
                // res.data 为0 是当期， 1是累计, Null 是没有
                if (res.data === null) {} else {
                    this.declaredType = res.data;
                    this.typeDisabled = true;
                }
            });
        },

        //tab切换
        handleClick(num) {
            this.currentIndex = +num;
            if (
                (this.showType === "sheet" && num !== "1003") ||
                (this.showType === "chart" && num !== "1003")
            ) {
                this.gettableData();
            } else {
                this.getListData();
            }
        },

        //button点击
        changeType(type) {
            this.showType = type;
            if (type === "sheet") {
                this.gettableData();
                this.value = "1"
            } else {
                this.gettableData(2);
                this.value = "2"
            }
        },

        // 点击列过滤
        changeFilter() {
            this.dialogModel.title = "列过滤";
            this.dialogModel.visible = true;
            this.dialogModel.addType = "filter";
        },

        //头部表单信息
        getheadform() {
            auditEchoHeader({ projectId: this.curProjectId }).then((res) => {
                if (res.code === 0) {
                    this.formInfo.shenBaoSum =
                        res.data.shenBaoSum === null ? 0 : res.data.shenBaoSum; // 累计申报进度款
                    this.formInfo.piZhunQiShu = res.data.piZhunQiShu; // 累计批进度期
                    this.formInfo.piZhunSum =
                        res.data.piZhunSum === null ? 0 : res.data.piZhunSum; // 累计批准进度款
                    this.formInfo.shenBaoBiLi =
                        res.data.shenBaoBiLi === null ? 0 + ".00%" : res.data.shenBaoBiLi; // 累计申报百分比
                    this.formInfo.kongZhiPrice = res.data.kongZhiPrice; // 控制价
                    this.formInfo.shenBaoQiShu = res.data.shenBaoQiShu; // 累计申报进度期
                    this.formInfo.piZhunBiLi =
                        res.data.piZhunBiLi == null ? 0 + ".00%" : res.data.piZhunBiLi; // 累计批准百分比
                    this.formInfo.heTongPrice = res.data.heTongPrice; // 合同价
                }
            });
        },

        // 点击导出
        changeExport(val, type) {
            if (this.treeDataList.length === 0) {
                this.$message.warning("当前没有要导出的数据....");
                return;
            }
            let saveName = "跟踪审计列表数据" + dateFormat("yyyy-MM-dd hh:ss:mm");
            if (val === 1003) {
                exportExcel(
                    "busTrackAudit/selectPeriodsDataExcel", {
                        aid: this.curProjectId,
                        shenBaoSum: this.formInfo.shenBaoSum,
                        piZhunQiShu: this.formInfo.piZhunQiShu,
                        piZhunSum: this.formInfo.piZhunSum,
                        shenBaoBiLi: this.formInfo.shenBaoBiLi,
                        kongZhiPrice: this.formInfo.kongZhiPrice,
                        shenBaoQiShu: this.formInfo.shenBaoQiShu,
                        piZhunBiLi: this.formInfo.piZhunBiLi,
                        heTongPrice: this.formInfo.heTongPrice,
                        costValue: this.formInfo.heTongPrice,
                        exportType: type,
                        saveName: saveName,
                    },
                    saveName
                );
            } else {
                exportExcel(
                    "busTrackAudit/auditEchoExcle", {
                        projectId: this.curProjectId,
                        type: this.currentIndex === 1001 && this.currentIndex !== 1003 ?
                            0 : 1,
                        unitType: this.value === "1" ? "0" : "1",
                        param2: this.formInfo,
                        exportType: type,
                        saveName: saveName,
                    },
                    saveName
                );
            }
        },

        // 点击自动分析生成报告
        chooseExport() {
            // 实时判断价格是否有更新
            this.judgePrice()

            this.dialogModel.addType = 'analysisExport';
            this.dialogModel.title = '自动分析生成报告';
            this.dialogModel.visible = true;
            this.dialogModel.width = "1100px";
        },

        //新增
        addPayment() {
            if (
                parseFloat(this.formInfo.kongZhiPrice) == 0 ||
                parseFloat(this.formInfo.heTongPrice) == 0
            ) {
                this.$message.warning("请先上传 控制价 与 中标价 ！");
                return;
            }

            this.dialogModel.visible = true;
            this.dialogModel.addType = 1;
            this.dialogModel.title = "新增进度款";
            if (this.activeName === "1001") {
                this.addForm.costType = "0"
            } else if (this.activeName === "1002") {
                this.addForm.costType = "1"
            }
            // 获取 当前项目的 申报金额类型
            this.getProjectType();
        },

        // 关闭弹窗事件
        handleClose() {
            if (this.dialogModel.addType === 10) {
                this.dialogModel.width = "750px";
                this.dialogModel.addType = 1;
                this.addForm.softName = "";
            } else {
                this.dialogModel.visible = false;
                this.dialogModel.addType = 0;
                this.dialogModel.type = "add";
                this.dialogModel.width = "750px";
                this.btnLoading = false;
                this.$refs.myUpload ? this.$refs.myUpload.clearFiles() : "";
                // 清空addForm
                this.addForm.fileType = "0";
                this.addForm.numberPeriods = "";
                this.addForm.amount = 0;
                this.addForm.changeActualValue = 0;
                this.addForm.totalInterimCost = 0;
                this.addForm.busImpList = [];
                this.addForm.dateBirth = "";
                this.addForm.stopDate = "";
                this.addForm.busRemark = "";
                this.addForm.param = "";
                this.addForm.param1 = "";
                this.addForm.treeId = "";
                this.addForm.softName = "";
                this.addForm.isData = "";
                this.addForm.sheetList = [];
                this.addForm.treeData = [];
            }

            // 删除附件
            if (this.saveFileId.length > 0) {
                this.deleteFile()
            }

            if (this.timer) {
                clearInterval(this.timer)
            }
        },

        // 新增期数 填写事件
        onInput(val) {
            if (parseFloat(val) >= 1) {
                // 检验当期是否已有数据
                judgeIsDataByPeriod({
                    projectId: this.curProjectId,
                    type: this.addForm.costType,
                    periods: val,
                }).then((res) => {
                    // 先清空
                    if (this.addForm.id) {
                        delete this.addForm.id;
                    }
                    if (this.addForm.aid) {
                        delete this.addForm.aid;
                    }
                    this.addForm.busRemark = "";
                    this.addForm.busImpList = [];
                    this.addForm.amount = 0;
                    this.addForm.totalInterimCost = 0;
                    this.addForm.changeActualValue = 0;

                    if (res.code === 0 && res.data.length > 0) {
                        this.addForm.id = res.data[0].id;
                        this.addForm.aid = res.data[0].aid;
                        this.addForm.amount = res.data[0].costValue;
                        this.addForm.totalInterimCost = res.data[0].totalInterimCost;
                        this.addForm.changeActualValue = res.data[0].changeActualValue;
                        this.addForm.busRemark = res.data[0].imageProgressDescribe;
                        this.addForm.busImpList.push(res.data[0].dateBirth);
                        this.addForm.busImpList.push(res.data[0].stopDate);
                    }
                });
            } else {
                this.addForm.numberPeriods = 1;
            }
        },

        // 弹窗点击确认
        doConfirm() {
            this.btnLoading = true;

            // 如果是第一级展开 ---- 新增进度款
            if (this.dialogModel.addType === 1) {
                let _addList = this.$refs.myUpload.addList;
                if (_addList.length === 0) {
                    this.$message.warning("请上传具体的文件!");
                    this.resetBtnloading();
                    return;
                }
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        // 存储当前的文件
                        this.fileList = _addList;
                        // 进度条
                        this.progressData.eventList = _addList.filter(x => !x.id)
                        this.progressData.eventList.map((i) => {
                            i.progress = 0
                            i.progressLoading = true
                        })

                        // 如果是xml 直接预览
                        if (this.addForm.fileType === "0") {
                            this.doPreviewXml();
                        } else {
                            this.dialogModel.addType = 2;
                            this.dialogModel.title = "选择上传文件所属节点";
                            this.dialogModel.type = "add";
                            this.dialogModel.width = "750px";
                            this.btnLoading = false;
                        }
                    } else {
                        this.resetBtnloading();
                    }
                });
                // 上传xml确认
            } else if (this.dialogModel.addType === 2) {
                // 如果是 excel
                if (this.addForm.fileType === "1") {
                    // 第二级确定
                    let _choose = this.$refs.structureList.chooseName;
                    if (_choose === "") {
                        this.$message.warning("请选择一个文件节点!");
                        this.resetBtnloading();
                    } else {
                        // 预览文件
                        this.btnLoading = false;
                        // 存储当前信息
                        this.addForm.isData = this.$refs.structureList.isData;
                        this.addForm.treeId = _choose;
                        this.doPreview(_choose);
                    }
                } else {
                    this.$refs.xmlPreview.doSubmit().then((res) => {
                        // console.log(res)
                        if (res) {
                            // 赋值
                            this.addForm.sheetList = this.$refs.xmlPreview.leftData;

                            let list = [];
                            this.$refs.xmlPreview.leftData.forEach((x) => {
                                if (x.danWeiId) {
                                    list.push(x.danWeiId);
                                }
                            });
                            this.addForm.isData = "1";
                            this.resetaddForm.danWeiId = list.join(",");

                            this.doSave();
                        } else {
                            this.resetBtnloading();
                        }
                    });
                }
                // 上传excel确认
            } else if (this.dialogModel.addType === 3) {
                // 确认上传 Excel
                this.doSave();
                // 从差异页面 进入xml 预览
            } else if (this.dialogModel.addType === 10) {
                if (this.addForm.softName.replace(/\s+/g, "") === "") {
                    this.$message.warning("请填写 差异说明!");
                    this.resetBtnloading();
                    return;
                }
                this.resetBtnloading();
                this.dialogModel.addType = 2;
                this.dialogModel.title = "xml 导入数据预览";
                this.dialogModel.type = "add";
                this.dialogModel.width = "1100px";
                // 自动分析导出
            } else if (this.dialogModel.addType === 'analysisExport') {
                //处理 自动分析数据
                this.dealAnalysis()
                // 列过滤
            } else {
                // 列过滤确认
                if (this.$refs.trackauditPayment) {
                    this.$refs.trackauditPayment.filterColumns = this.checkedColumns;

                    setTimeout(() => {
                        this.$refs.trackauditPayment.resizeTable();
                    }, 300);
                }

                if (this.$refs.trackdataComparison) {
                    this.$refs.trackdataComparison.filterColumns = JSON.parse(
                        JSON.stringify(this.compareCheck)
                    );

                    setTimeout(() => {
                        this.$refs.trackdataComparison.resizeTable();
                    }, 300);
                }

                // 关闭弹窗
                setTimeout(() => {
                    this.handleClose();
                }, 300);
            }
        },

        //  >>> ---------  自动分析模块 -------------------
        // 判断 六算及其他价格 是否存在数据
        judgePrice() {
            let arr = []
            checkFileZipIsData({projectId: this.curProjectId})
                .then(res => {
                    // 处理数据
                    this.dealData(res.data)
                })
        },

        // 判断的价格 处理数据
        dealData(arr) {
            // 跟踪审计
            let _track = this.analysisList.find(x => x.prop === 'trackingAudit')
            _track.children.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = _item.disabled
                x.selected = !x.disabled
            })
            _track.disabled = _track.children.filter(x => !x.disabled).length === 0
            _track.checkAll = _track.children.filter(x => !x.disabled).filter(x => x.selected).length !== 0
            _track.selected = !_track.disabled

            // 六算分析表处理
            let _analysisSheet = this.analysisList.find(x => x.prop === 'analysisSheet')
            _analysisSheet.children[0].list.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = _item.disabled
            })
            _analysisSheet.children[0].selected = _analysisSheet.children[0].list[2].disabled ? '' : '1007003'

            _analysisSheet.children[1].list.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = _item.disabled
            })
            _analysisSheet.children[1].selected = _analysisSheet.children[1].list[5].disabled ? [] : ['1007006']
            _analysisSheet.disabled = _analysisSheet.children[1].list.filter(x => !x.disabled).length === 0
            _analysisSheet.selected = !_analysisSheet.disabled && _analysisSheet.children[1].selected.length > 0

            // 详细分析
            let _analysisDetail = this.analysisList.find(x => x.prop === 'analysisDetail')
            _analysisDetail.children[0].list.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = x.prop === '1007001' ? true : _item.disabled
            })
            _analysisDetail.children[0].selected = _analysisDetail.children[0].list[2].disabled ? '' : '1007003'

            _analysisDetail.children[1].list.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = x.prop === '1007001' ? true : _item.disabled
            })
            _analysisDetail.children[1].selected = _analysisDetail.children[1].list[5].disabled ? '' : '1007006'

            _analysisDetail.disabled = _analysisDetail.children[0].list.filter(x => !x.disabled).length === 0
            _analysisDetail.selected = !_analysisDetail.disabled && _analysisDetail.children[0].selected !== '' && _analysisDetail.children[1].selected !== ''

            // 清单检查
            let _analysisInventory = this.analysisList.find(x => x.prop === 'analysisInventory')
            _analysisInventory.children.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = x.prop === '1007001' ? true : _item.disabled
                x.selected = x.prop === '1007006' && !x.disabled
            })
            _analysisInventory.disabled = _analysisInventory.children.filter(x => !x.disabled).length === 0
            // _analysisInventory.checkAll = _analysisInventory.children.filter(x => !x.disabled).filter(x => x.selected).length !== 0
            let _checkInventory = _analysisInventory.children.filter(x => !x.disabled).filter(x => x.selected).length !== 0
            _analysisInventory.selected = !_analysisInventory.disabled && _checkInventory

            // 材价检查
            let _analysisMaterial = this.analysisList.find(x => x.prop === 'analysisMaterial')
            _analysisMaterial.children.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = x.prop === '1007001' ? true : _item.disabled
                x.selected = x.prop === '1007006' && !x.disabled
            })
            _analysisMaterial.disabled = _analysisMaterial.children.filter(x => !x.disabled).length === 0
            // _analysisMaterial.checkAll = _analysisMaterial.children.filter(x => !x.disabled).filter(x => x.selected).length !== 0
            // _analysisMaterial.selected = !_analysisMaterial.disabled
            let _checkMaterial = _analysisInventory.children.filter(x => !x.disabled).filter(x => x.selected).length !== 0
            _analysisMaterial.selected = !_analysisMaterial.disabled && _checkMaterial

            // 签证对比 analysisVisa
            let _analysisVisa = this.analysisList.find(x => x.prop === 'analysisVisa')
            _analysisVisa.children[0].list.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = x.prop === '1007001' ? true : _item.disabled
            })
            _analysisVisa.children[0].selected = _analysisVisa.children[0].list[5].disabled ? '' : '1007006'

            _analysisVisa.children[1].list.map(x => {
                let _item = arr.find(y => y.prop === x.prop)
                x.disabled = _item.disabled
            })
            _analysisVisa.children[1].selected = _analysisVisa.children[1].list[2].disabled ? '' : '1055001'

            _analysisVisa.disabled = _analysisVisa.children[0].list.filter(x => !x.disabled).length === 0
            _analysisVisa.selected = !_analysisVisa.disabled && _analysisVisa.children[0].selected !== '' && _analysisVisa.children[1].selected !== ''
        },

        // 行样式
        activeAnalysisStyle(row) {
            if (row.subTitle && row.subTitle !== '' && row.childrenType === 'checkbox') {
                return {
                    lineHeight: '71px'
                }
            }
        },

        analysisColStyle(row) {
            // 签证对比
            if (!row.subTitle && row.children.length === 2 && row.prop === 'analysisVisa') {
                return {
                    lineHeight: '71px'
                }
            }

            // 六算分析表
            if (!row.subTitle && row.children.length === 2 && row.prop === 'analysisSheet') {
                return {
                    lineHeight: '71px'
                }
            }
        },

        // 自动分析 切换复选框事件
        analysisChange(val, item) {
            let _false = item.children.filter(x => !x.disabled).find(x => x.selected === false)
            item.checkAll = _false ? false : true

            let _true = item.children.find(x => x.selected)
            item.selected = _true ? true : false
        },

        // 自动分析 --- 混合型 复选框切换
        analysisMixChange(val, m, item) {
            if (val.length === m.list.filter(x => !x.disabled).length) {
                item.checkAll = true
            } else {
                item.checkAll = false
            }

            // 是否选中
            if (val.length > 0) {
                item.selected = true
            } else {
                item.selected = false
            }
        },

        // 自动分析 全选
        analysisCheckAll(val, item) {
            if (item.childrenType === 'checkbox') {
                item.children.map(x => {
                    x.type === 'checkbox' && !x.disabled ? x.selected = val : ''
                // x.type === 'radio' && !x.disabled ? x.selected = ''
                })
            }

            if (item.childrenType === 'mix') {
                item.children.map(x => {
                    if (x.type === 'checkbox') {
                        let arr = x.list.filter(y => !y.disabled)
                        x.selected = val ? arr.map(x => x.prop) : []
                    }

                    if (x.type === 'radio') {
                        x.selected = val ? '1007003' : '1007003'
                    }
                })
            }
            

            item.selected = val
        },

        // 自动分析选择模块
        analysisSelected(val, item) {
            item.checkAll = val

            this.analysisCheckAll(val, item)
        },

        // 处理自动分析数据
        dealAnalysis() {
            // 处理详细数据
            let _continue = true
            this.analysisList.map(x => {
                // 如果是 分析报告（基础模块）
                if (x.prop === 'analysisReport') {
                    x.projectInfo = this.$utils.clone(this.projectInfo, true)
                }

                // 如果是 跟踪审计模块
                if (x.prop === 'trackingAudit') {
                    let params_1 = {
                        projectId: this.curProjectId,
                        unitType: this.value === "1" ? "0" : "1",
                        param2: this.formInfo,
                        exportType: 'excel',
                    }
                    x.children[0].exportObj = params_1
                    x.children[0].exportObj.type = 0

                    x.children[1].exportObj = params_1
                    x.children[1].exportObj.type = 1

                    x.children[2].exportObj = {
                        aid: this.curProjectId,
                        shenBaoSum: this.formInfo.shenBaoSum,
                        piZhunQiShu: this.formInfo.piZhunQiShu,
                        piZhunSum: this.formInfo.piZhunSum,
                        shenBaoBiLi: this.formInfo.shenBaoBiLi,
                        kongZhiPrice: this.formInfo.kongZhiPrice,
                        shenBaoQiShu: this.formInfo.shenBaoQiShu,
                        piZhunBiLi: this.formInfo.piZhunBiLi,
                        heTongPrice: this.formInfo.heTongPrice,
                        costValue: this.formInfo.heTongPrice,
                        exportType: 'excel',
                    }
                }

                // 如果是 六算分析模块
                if (x.prop === 'analysisSheet') {
                    let params_2 = {
                        projectId: this.curProjectId,
                        type: 'excel',
                        base: x.children[0].selected,
                        compares: x.children[1].selected
                    }
                    x.sheetParams = params_2
                }

                // 如果是详细分析
                if (x.prop === 'analysisDetail') {
                    x.phase1 = x.children[0].selected
                    x.phase2 = x.children[1].selected
                    x.rules = x.rules.perPrice ? x.rules : this.curRule

                    if ((x.selected && x.phase1 === '') || (x.selected && x.phase2 === '')) {
                        this.$message.warning('请选择详细分析对比值！')
                        _continue = false
                    }
                }

                // 如果是 清单检查/材价检查
                if (x.prop === 'analysisInventory' || x.prop === 'analysisMaterial') {
                    x.sortField = x.sortField.length > 0 ? x.sortField : []
                }

                // 如果是 签证模块
                if (x.prop === 'analysisVisa') {
                    x.phase1 = x.children[1].selected
                    x.phase2 = x.children[0].selected

                    if ((x.selected && x.phase1 === '') || (x.selected && x.phase2 === '')) {
                        this.$message.warning('请选择签证对比的价格！')
                        _continue = false
                    }
                }
            })

            if (!_continue) {
                setTimeout(() => {
                    this.btnLoading = false
                }, 1500)
                return
            }

            //xml 预览操作
            this.progressData.show = true
            this.progressData.eventList.push({
                name: "自动分析报告" + dateFormat("yyyy-MM-dd hh:ss:mm"),
                progress: 0,
                progressLoading: true
            })

            this.timer = setInterval(() => {
                this.progressData.eventList[0].progress += Math.floor((Math.random() * 10) + 1)

                if (this.progressData.eventList[0].progress >= 90) {
                    clearInterval(this.timer)
                }
            }, 500)

            // 第一级过滤
            let _root = JSON.parse(JSON.stringify(this.analysisList))
            _root = _root.filter(x => x.selected)

            // 第二级过滤
            _root.map(x => {
                x.children = x.children.filter(x => x.selected)
            })

            // 导出文件名
            let saveName = "自动分析报告" + dateFormat("yyyy-MM-dd hh:ss:mm");

            let params = {
                projectId: this.curProjectId,
                list: _root
            }

            exportExcel('busTrackAudit/fileZip', params, saveName)
                .then(res => {
                    if (this.timer) {
                        clearInterval(this.timer)
                    }
                    // 进度条
                    this.progressData.eventList[0].progressInfo = '解析成功'
                    this.progressData.eventList[0].progress = 100
                    this.progressData.eventList[0].progressLoading = false

                    setTimeout(() => {
                        this.progressData.show = false
                        this.progressData.eventList = []
                        this.btnLoading = false
                    }, 500)
                })
        },

        // 获取详细分析的规则
        getRules() {
            let param = {};
            param.isSys = this.isSys;
            getRulesList(param)
                .then((res) => {
                    // 加载 系统默认规则
                    let _default = res.data.find((x) => x.isDefault === 1);
                    if (_default) {
                        this.curRule = _default.rules;
                    }
                })
                .catch((err) => {
                    this.curRule = {}
                });
        },

        // 添加详细分析
        addParams(type, index) {
            switch (type) {
                // 详细分析
                case 'analysisDetail':
                    let params1 = this.analysisList.find(x => x.prop === 'analysisDetail' && x.btnIndex === 0)
                    let _add1 = this.$utils.clone(params1, true)
                    _add1.btnIndex = index + 1;
                    this.analysisList.splice(index + 1, 0, _add1)

                    // 重新排个序（标题）
                    this.analysisList.filter(x => x.prop === 'analysisDetail').map((y, index) => {
                        y.title = `附件3.${index + 1}：详细分析`
                    })
                    
                    break;
                // 签证
                case 'analysisVisa':
                    let params2 = this.analysisList.find(x => x.prop === 'analysisVisa' && x.btnIndex === 0)
                    let _add2 = this.$utils.clone(params2, true)
                    _add2.btnIndex = index + 1;
                    this.analysisList.splice(index + 1, 0, _add2)

                    // 重新排个序（标题）
                    this.analysisList.filter(x => x.prop === 'analysisVisa').map((y, index) => {
                        y.title = `附件6.${index + 1}：签证对比`
                    })
                    break;
            }
        },

        // 删除item
        removeParams(type, index) {
            this.analysisList.splice(index, 1)
        },

        // 打开规则弹窗（手动分析）
        openRule(item) {
            // 暂时保存对象
            this.curDetailItem = item

            this.ruleDialog.mode = 'edit';
            this.ruleDialog.step = 2;
            this.ruleDialog.width = "1200px";
            this.ruleDialog.visible = true;

            setTimeout(() => {
                this.$refs.ruleTable.tableLoading = false
                this.$refs.ruleTable.rules = item.rules.perPrice ? item.rules : this.$refs.ruleTable.rules
            }, 1000)
        },

        // 规则弹窗确认
        onRuleConfirm() {
            if (this.$refs.ruleTable) {
                // 保存当前规则
                this.curDetailItem.rules = this.$utils.clone(this.$refs.ruleTable.rules, true);

                // 更新保存一次规则
                this.ruleDialog.visible = false
            }
        },

        // 规则弹窗关闭
        handleRuleClose() {
            this.ruleDialog.step = 0;
        },

        // 排序模块 -------
        // 打开排序弹窗
        openSort(type, item) {
            this.sortDialog.title = type === 'inventory' ? "联合排序" : '分类排序';
            this.sortDialog.type = type;
            this.sortDialog.visible = true;

            // 赋值
            if (type === 'inventory' && item.sortField.length > 0) {
                this.sortObj.inventoryList.map(x => {
                    x.visible = item.sortField.includes(x.key)
                })
            }

            if (type === 'material' && item.sortField.length > 0) {
                this.sortObj.materialList.map(x => {
                    x.visible = item.sortField.includes(x.key)
                })
            }
        },

        // 排序全选
        handleAllSortChange(val, type) {
            this.sortObj[type].map(x => {
                x.visible = val
            })
        },

        // 确认排序
        doSort() {
            switch (this.sortDialog.type) {
                case 'inventory':
                    let _sort1 = this.sortObj.inventoryList.filter(x => x.visible)
                    let _item1 = this.analysisList.find(x => x.prop === 'analysisInventory')
                    _item1.sortField = _sort1.map(x => x.key) || []
                    break;
                case 'material':
                    let _sort2 = this.sortObj.materialList.filter(x => x.visible)
                    let _item2 = this.analysisList.find(x => x.prop === 'analysisMaterial')
                    _item2.sortField = _sort2.map(x => x.key) || []
                    break;
            }

            this.handleSortClose();
        },

        // 排序弹窗关闭
        handleSortClose() {
            this.sortDialog.visible = false;
            this.sortDialog.btnLoading = false;
        },

        //  <<< ------------ 自动分析结束 ---------------------

        // 文件预览 --xml
        doPreviewXml(callbackFn) {
            let formData = new FormData();
            for (let item of this.fileList) {
                formData.append("file", item);
            }
            formData.append("fileType", this.addForm.fileType === "0" ? 0 : 1);
            formData.append('projectId', this.curProjectId)

            // loading
            // this.pageLoading = this.$loading({
            //     lock: true,
            //     text: "正在解析中...",
            //     spinner: "el-icon-loading",
            // });

            //xml 预览操作
            this.progressData.show = true
            parseXml(formData, this.progressFn, 0)
                .then((res) => {
                    // loading
                    // this.pageLoading.close();

                    if (res.code === 0) {
                        // 进度条
                        this.progressData.eventList[0].progressInfo = '解析成功'
                        this.progressData.eventList[0].progress = 100
                        this.progressData.eventList[0].progressLoading = false
                        let data = this.progressData.eventList[0]
                        this.$set(this.progressData.eventList, 0, data)

                        this.addForm.sheetList = res.data.param1;
                        this.addForm.param = res.data.param3;
                        this.addForm.fileType = res.data.param2.fileType;
                        this.addForm.fileAmount = res.data.fileAmount;

                        setTimeout(() => {
                            this.progressData.show = false
                            this.progressData.eventList = []
                            this.saveFileId = res.data.fileId

                            // 如果 填写金额 与 文件金额不符，打开 说明弹窗
                            if (
                                parseFloat(this.addForm.amount) !==
                                parseFloat(res.data.fileAmount)
                            ) {
                                this.addForm.softName = ''
                                this.dialogModel.addType = 10;
                                this.dialogModel.title = "差异金额说明";
                                this.dialogModel.type = "add";
                                this.dialogModel.width = "500px";
                            } else {
                                this.dialogModel.addType = 2;
                                this.dialogModel.title = "xml 导入数据预览";
                                this.dialogModel.type = "add";
                                this.dialogModel.width = "1100px";
                            }

                            this.btnLoading = false;
                            this.resetaddForm = res.data;
                        }, 500)
                    } else {
                        this.progressData.eventList[0].progressInfo = '解析失败，请重新上传！'
                        this.progressData.eventList[0].progressLoading = false
                        let data = this.progressData.eventList[0]
                        this.$set(this.progressData.eventList, 0, data)

                        this.resetBtnloading();
                    }
                })
                .catch((err) => {
                    // loading
                    // this.pageLoading.close();

                    this.progressData.eventList[0].progressInfo = '解析失败，请重新上传！'
                    this.progressData.eventList[0].progressLoading = false
                    let data = this.progressData.eventList[0]
                    this.$set(this.progressData.eventList, 0, data)

                    this.resetBtnloading();
                });
        },

        // 上传进度函数
        progressFn(progressEvent, index) {
            if (this.progressData.eventList.length > 0) {
                this.progressData.eventList[index].progress =
                    ((progressEvent.loaded / progressEvent.total) * 100) | 0

                // 特殊处理
                if (progressEvent.loaded / progressEvent.total >= 0.9) {
                    this.progressData.eventList[index].progress = 90
                }
                if ((progressEvent.loaded / progressEvent.total) === 1) {
                    this.progressData.eventList[index].progressInfo =
                        '正在解析文件, 请稍后....'
                } else {
                    this.progressData.eventList[index].progressInfo = '正在上传'
                }
                let data = this.progressData.eventList[index]
                this.$set(this.progressData.eventList, index, data)
            }
        },

        // 文件预览 ---excel
        doPreview(danWeiId) {},

        // 确认上传excel或xml
        doSave() {
            let params = JSON.parse(JSON.stringify(this.resetaddForm));
            params.param2.projectId = this.curProjectId;
            params.param2.fileName = this.resetaddForm.param3;
            params.param2.phase = this.addForm.phase;
            params.param2.priceBasis = this.addForm.priceBasis;

            params.param2.numberPeriods = this.addForm.numberPeriods;
            params.param2.costValue = this.addForm.amount;
            params.param2.totalInterimCost = this.addForm.totalInterimCost;
            params.param2.changeActualValue = this.addForm.changeActualValue;
            params.param2.type = this.addForm.costType;

            params.param2.dateBirth = this.addForm.busImpList[0];
            params.param2.stopDate = this.addForm.busImpList[1];
            params.param2.imageProgressDescribe = this.addForm.busRemark;
            params.param2.id = this.addForm.id;

            params.declaredType = this.declaredType;

            let resetparam1 = this.addForm.sheetList.filter((x) => {
                return x.danWeiId !== "" && x.danWeiId !== undefined;
            });
            let { param3, ...object } = params;
            params = object;
            params = { ...params, param1: resetparam1 };

            // loading
            this.pageLoading = this.$loading({
                lock: true,
                text: "正在导入中...",
                spinner: "el-icon-loading",
            });

            // 保存
            saveXmlAndPayment(params)
                .then((res) => {
                    // loading
                    this.pageLoading.close();

                    this.btnLoading = false;
                    if (res.code === 0) {
                        this.$message.success("保存成功！");
                        this.handleClose();
                        // 重新渲染数据
                        this.gettableData(res.data.type);
                        this.getheadform();
                    } else {
                        this.$message.error("保存失败！");
                    }
                })
                .catch((error) => {
                    // loading
                    this.pageLoading.close();

                    this.resetBtnloading();
                });
        },

        // 恢复按钮
        resetBtnloading() {
            setTimeout(() => {
                this.btnLoading = false;
                this.progressData.show = false
                this.progressData.eventList = []
            }, 2000);
        },

        // 删除文件
        deleteFile() {
            deleteFile({ id: this.saveFileId })
                .then(res => {
                    this.saveFileId = []
                })
        },

        // 列过滤弹窗 切换全选 currentIndex !==1003
        handleCheckAllChange(val) {
            let arr = this.filterColumns.map((x) => {
                return x.label;
            });
            this.checkedColumns = val ? arr : [];
            this.isIndeterminate = false;
        },

        // 列过滤复选框选择事件 currentIndex !==1003
        handleCheck(arr) {
            arr = arr.filter((x, index) => {
                return x !== "piZhunSum" && x !== "piZhunBiLi";
            });
            let checkedCount = arr.length;
            this.checkAll = checkedCount === this.filterColumns.length;
            this.isIndeterminate =
                checkedCount > 0 && checkedCount < this.filterColumns.length;
        },

        // 列过滤全选 --- 对比数据 currentIndex ===1003
        handleCheckAllCompare(val, type) {
            let current_arr = this.filterColumnsNew[type].map((x) => {
                return x.label;
            });

            if (val) {
                this.compareCheck[type] = current_arr;
            } else {
                this.compareCheck[type] = [];
            }
            this.isIndeterminateCompare[type] = false;
        },

        // 当期点击事件 currentIndex ===1003
        handleCheckNew(arr, type) {
            let current_length = this.compareCheck[type].length;

            if (current_length === this.filterColumnsNew[type].length) {
                this.checkAllCompare[type] = true;
                this.isIndeterminateCompare[type] = false;
            } else {
                this.checkAllCompare[type] = false;
                this.isIndeterminateCompare[type] = true;
            }
        },

        //获取列表数据 currentIndex !==1003
        gettableData(val) {
            // 先清空数组
            this.treeDataList = [];
            this.checkedColumns = [
                "heTongPrice",
                "shenBaoSum",
                "piZhunSum",
                "shenBaoBiLi",
                "piZhunBiLi",
                "shengYuShenBao",
            ];

            // 列过滤确认
            if (
                this.$refs.trackauditPayment &&
                this.currentIndex !== 1003 &&
                this.showType !== "chart"
            ) {
                this.$refs.trackauditPayment.filterColumns = this.checkedColumns;

                setTimeout(() => {
                    this.$refs.trackauditPayment.resizeTable();
                }, 300);
            }
            auditEcho({
                projectId: this.curProjectId,
                type: val ?
                    val : this.currentIndex === 1001 && this.currentIndex !== 1003 ?
                    0 : 1,
            }).then((res) => {
                if (res.code === 0 && res.data !== null) {
                    // this.formInfo = res.data.param2
                    this.formInfo.declareProgressPayment =
                        res.data.param2.declareProgressPayment;
                    this.formInfo.examineProgressPayment =
                        res.data.param2.examineProgressPayment;

                    this.treeDataList.push(res.data.param1);
                    if (
                        this.treeDataList.length > 0 &&
                        res.data.param1.tianBaoMoney !== []
                    ) {
                        this.periodsList = res.data.param1.tianBaoMoney;
                        let floatList = res.data.param1.tianBaoMoney;

                        this.periodsList.map((item, index) => {
                            let curObj = floatList.find(
                                (x) => x.number_periods === item.number_periods
                            );
                            item.float = curObj.cost_value;
                            // this.checkedColumns.push(
                            //  `shenBaoList[${index}].cost_value`
                            // )
                        });

                        // 列过滤确认
                        if (this.$refs.trackauditPayment) {
                            this.$refs.trackauditPayment.filterColumns = this.checkedColumns;

                            setTimeout(() => {
                                this.$refs.trackauditPayment.resizeTable();
                            }, 300);
                        }
                        // console.log(this.checkedColumns)
                    }
                } else {
                    this.$Message.error("查询出错，请联系管理员!");
                }
            });
        },

        // 获取数据 currentIndex ===1003
        getListData() {
            this.listData = [];
            this.compareCheck = {
                current: ["taostValue", "costMoney", "tostValue", "sunMoney"],
                total: ["applyMoney", "approvalMoney", "visaMoney", "payMoney"],
                Declare: [],
            };

            selectPeriodsData({
                    aid: this.curProjectId,
                    costValue: this.formInfo.heTongPrice,
                })
                .then((res) => {
                    this.listData = res.data;
                })
                .catch((err) => {});
        },
    },
    computed: {
        ...mapState("menu", {
            roleBtns: (state) => state.roleBtns,
        }),
        ...mapState('app', {
            projectInfo: state => state.projectInfo
        }),
        // 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
        curSource() {
            return this.$route.query.source || '0'
        },
        // 当前单位名称
        unitName() {
            let item = this.options.find((x) => x.value === this.value);
            return item ? item.label : "";
        },

        // 当前项目ID
        curProjectId() {
            return this.$route.query.projectId;
        },

        // 文件上传 文件类型
        acceptType() {
            return this.addForm.fileType === "1" ? ["xls", "xlsx"] : ["xml", "XML"];
        },

        // 列过滤 全部数组 --- currentIndex !== 1002
        filterColumns() {
            let arr = [
                { label: "heTongPrice", sname: "合同价款" },
                this.currentIndex === 1001 ? { label: "shenBaoSum", sname: "累计申报进度款" } : { label: "piZhunSum", sname: "累计审核进度款" },
                { label: "piZhunBalance", sname: "余额" },
                this.currentIndex === 1001 ? { label: "shenBaoBiLi", sname: "累计申报比例" } : { label: "piZhunBiLi", sname: "累计审核比例" },
                { label: "shengYuShenBao", sname: "剩余比例" },
            ];

            // 期数数组控制
            if (this.periodsList.length > 0) {
                if (this.currentIndex === 1001) {
                    this.periodsList.map((item, index) => {
                        arr.push({
                            label: `shenBaoList[${index}].cost_value`,
                            sname: `第${item.number_periods}期`,
                        });
                    });
                } else {
                    this.periodsList.map((item, index) => {
                        arr.push({
                            label: `piZhunList[${index}].cost_value`,
                            sname: `第${item.number_periods}期`,
                        });
                    });
                }
            }
            return arr;
        },

        // 列过滤全部数组 --- currentIndex === 1003
        filterColumnsNew() {
            let obj = {
                Declare: [
                    { label: "sindex", sname: "申报描述" },
                    { label: "costName", sname: "审核描述" },
                ],
                current: [
                    { label: "taostValue", sname: "申请金额" },
                    { label: "costMoney", sname: "审核金额" },
                    { label: "tostValue", sname: "签证金额" },
                    { label: "sunMoney", sname: "支付金额" },
                    { label: "costProportion", sname: "申请占比" },
                    { label: "costPortion", sname: "审核占比" },
                    { label: "sunProportion", sname: "签证占比" },
                    { label: "applyProportion", sname: "支付占比" },
                ],
                total: [
                    { label: "applyMoney", sname: "申请金额" },
                    { label: "approvalMoney", sname: "审核金额" },
                    { label: "visaMoney", sname: "签证金额" },
                    { label: "payMoney", sname: "支付金额" },
                    { label: "applyPtion", sname: "申请占比" },
                    { label: "approvalProportion", sname: "批准占比" },
                    { label: "visaProportion", sname: "签证占比" },
                    { label: "payProportion", sname: "支付占比" },
                ],
            };
            return obj;
        },

        // 表头信息展示
        headerInfo() {
            let _kongZhiPrice = 0,
                _declareProgressPayment = 0,
                _shenBaoSum = 0,
                _heTongPrice = 0,
                _piZhunSum = 0,
                _examineProgressPayment = 0;
            switch (this.unitName) {
                case "元":
                    // 控制价
                    _kongZhiPrice = this.formInfo.kongZhiPrice || "0.00";

                    // 累计申报产值
                    _shenBaoSum = this.formInfo.shenBaoSum || "0.00";

                    // 累计申报进度款
                    _declareProgressPayment =
                        this.formInfo.declareProgressPayment || "0.00";

                    // 合同价
                    _heTongPrice = this.formInfo.heTongPrice || "0.00";

                    // 累计审核产值
                    _piZhunSum = this.formInfo.piZhunSum || "0.00";

                    // 累计审核进度款
                    _examineProgressPayment =
                        this.formInfo.examineProgressPayment || "0.00";
                    break;
                case "万元":
                    // 控制价
                    _kongZhiPrice = this.formInfo.kongZhiPrice ?
                        (this.formInfo.kongZhiPrice / 10000).toFixed(2) :
                        "0.00";

                    // 累计审核产值
                    _shenBaoSum = this.formInfo.shenBaoSum ?
                        (this.formInfo.shenBaoSum / 10000).toFixed(2) :
                        "0.00";

                    // 累计审核进度款
                    _declareProgressPayment = this.formInfo.declareProgressPayment ?
                        (this.formInfo.declareProgressPayment / 10000).toFixed(2) :
                        "0.00";

                    // 合同价
                    _heTongPrice = this.formInfo.heTongPrice ?
                        (this.formInfo.heTongPrice / 10000).toFixed(2) :
                        "0.00";

                    // 累计审核产值
                    _piZhunSum = this.formInfo.piZhunSum ?
                        (this.formInfo.piZhunSum / 10000).toFixed(2) :
                        "0.00";

                    // 累计审核进度款
                    _examineProgressPayment = this.formInfo.examineProgressPayment ?
                        (this.formInfo.examineProgressPayment / 10000).toFixed(2) :
                        "0.00";
                    break;
            }
            return {
                kongZhiPrice: _kongZhiPrice + " " + this.unitName,
                declareProgressPayment: _declareProgressPayment + " " + this.unitName,
                shenBaoSum: _shenBaoSum + " " + this.unitName,
                heTongPrice: _heTongPrice + " " + this.unitName,
                piZhunSum: _piZhunSum + " " + this.unitName,
                examineProgressPayment: _examineProgressPayment + " " + this.unitName,
            };
        },
    },
    watch: {
        // 监听新增进度款类型 的变化
        "addForm.costType": {
            handler: function(val) {
                if (this.addForm.numberPeriods === "" || this.dialogModel.addType !== 1) {
                    return;
                }
                // 调用期数接口
                judgeIsDataByPeriod({
                    projectId: this.curProjectId,
                    type: +val,
                    periods: this.addForm.numberPeriods + "",
                }).then((res) => {
                    // 先清空
                    if (this.addForm.id) {
                        delete this.addForm.id;
                    }
                    if (this.addForm.aid) {
                        delete this.addForm.aid;
                    }
                    this.addForm.busRemark = "";
                    this.addForm.busImpList = [];
                    this.addForm.amount = 0;
                    this.addForm.changeActualValue = 0;

                    if (res.code === 0 && res.data.length > 0) {
                        this.addForm.id = res.data[0].id;
                        this.addForm.aid = res.data[0].aid;
                        this.addForm.amount = res.data[0].costValue;
                        this.addForm.changeActualValue = res.data[0].changeActualValue;
                        this.addForm.busRemark = res.data[0].imageProgressDescribe;
                        this.addForm.busImpList.push(res.data[0].dateBirth);
                        this.addForm.busImpList.push(res.data[0].stopDate);
                    }
                });
            },
            deep: true,
        },
    },
};
</script>
<style scoped lang="less">
.tracking_audit {
    height: 100%;
    box-sizing: border-box;

    .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        font-size: 0;
        clear: both;
        visibility: hidden;
    }

    .track-header {
        width: 100%;
        display: flex;
        border-bottom: 2px solid #e4e7ed;

        .menutab {
            height: 100%;
            flex: 1;
        }

        .track-center {
            flex: 1;

            .el-select {
                width: 100px;
            }

            .flex {
                float: left;
                align-items: center;
                height: 100%;

                .activeBtn {
                    background-color: #c5eafc;
                    color: #006ebf;
                }
            }
        }

        .buttonclick {
            .flex {
                float: right;
            }
        }
    }

    .tracking-top {
        .el-form-item {
            margin-bottom: 0;
        }

        .el-form-item__content {
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
    }

    .classMore {
        height: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }
}

/deep/ .filter-block {
    min-height: 20px;
}

/deep/ .filter-header {
    background-color: #e5f7ff;
    height: 30px;
    line-height: 30px;
}

/deep/ .filter-text {
    padding-left: 5px;
}

// 自动分析报告弹窗页面样式设置
.analysis-container {
    max-height: 600px;
    overflow-y: auto;

    .note-text {
        padding: 10px;
        background-color: #f1f1f1;

        p {
            padding-left: 18px;
        }

        p:nth-of-type(1) {
            padding-left: 0;
            font-weight: 700;
        }
    }

    .block-row {
        @bdColor: #d5d9e3;

        margin: 10px 0;
        line-height: 35px;
        border: 1px solid @bdColor;

        .bd-right {
            border-right: 1px solid @bdColor;
        }

        .bd-top {
            border-top: 1px solid @bdColor;
        }

        .block-title {
            padding: 0 10px;
            background-color: #e1f0ff;
            border-right: 1px solid @bdColor;
        }

        .block-subTitle {
            text-indent: 1.5em;
            text-decoration: underline;
            color: #409eff;
            border-top: 1px solid @bdColor;
            cursor: pointer;
        }

        .tools-box {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .tools-btn {
            padding: 7px 10px;
            margin-top: 2px;
        }

        .tools-btn:last-child {
            margin-top: 8px;
            margin-left: 0;
        }
    }


}

.check-row {
    margin-bottom: 7px;
    background-color: #a3e3ff;
    height: 35px;
    line-height: 35px;
    font-weight: 700;
    color: #333;

    .check-name {
        border-right: 1px solid #1d7f8a;
        padding: 0 20px;
        position: relative;
        text-align: center;
    }

    .check-content {
        text-align: left;
        padding-left: 15px;
    }
}

.info-text {
    padding: 10px;
    background-color: #dbf4ff;
    text-align: left;
}
</style>